// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3tfFh","header-wrapper":"_3lT-B","header-title":"uGzQM","content":"vUZ7B","failure-msg":"_2yhGA","title1":"OQIYh","title2":"_247tF"};